import { Flex } from "antd";
import { FC } from "react";
import { MarketDebt } from "tm-shared/types";
import { formatUAHNarrow } from "tm-shared/utils";

import { MarketCard } from "@/components/MarketCard";
import { SecondaryText } from "@/components/Typography/Styled";

import {
    CurrencyVariant,
    StyledComment,
    StyledCurrency,
    StyledPaymentHeader,
} from "./Styled";

const getCurrencyColor = (debt?: MarketDebt): CurrencyVariant => {
    if (!debt) return "default";
    if (!debt.status) return "danger";

    return debt.payments?.some((p) => !p.isExported) ? "warning" : "default";
};

interface PaymentHeaderProps {
    debt: MarketDebt;
    isExported: boolean;
}

export const PaymentHeader: FC<PaymentHeaderProps> = ({ debt, isExported }) => {
    return (
        <StyledPaymentHeader
            $isCompleted={debt?.status}
            $isExported={isExported}
        >
            <Flex vertical gap={8}>
                <MarketCard
                    address={debt?.market?.address?.name || "-"}
                    fop={debt?.market?.contragent?.name || "-"}
                />
                {debt?.comment && <StyledComment>{debt.comment}</StyledComment>}

                <SecondaryText fontSize={16}>
                    Оплата:{" "}
                    <StyledCurrency $variant={getCurrencyColor(debt)}>
                        {formatUAHNarrow(debt?.paid ?? 0)}
                    </StyledCurrency>
                </SecondaryText>
            </Flex>
        </StyledPaymentHeader>
    );
};
